/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Author: dennissoderblom (https://sketchfab.com/dennissoderblom)
License: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
Source: https://sketchfab.com/3d-models/butterfly-365ce4edd01f4a15ad0336f51588128a
Title: Butterfly
*/

import React, { useRef, useEffect } from "react";
import { useGLTF, useAnimations } from "@react-three/drei";

export function Butterfly(props) {
  const group = useRef();
  const { nodes, materials, scene, animations } = useGLTF("./models/butterfly/scene.gltf", true);
  const { actions, mixer } = useAnimations(animations, group);

  useEffect(() => {
    // to slow down the animation on butterfly wings
    actions.Object_0.timeScale = 0.20;
    actions.Object_0.play();
  }, [mixer, actions]);

  return (
    <group ref={group} {...props} object={scene} dispose={null}>
      <group name="Sketchfab_Scene">
        <group name="Object_3">
          <group
            name="Object_6"
            position={[3.22, 0.013, 2.565]}
            rotation={[-Math.PI / 2, 0, 0]}
          >
            <group name="Object_7" position={[26.986, 0, 0]}>
              <group name="MorphMainGroup">
                <mesh
                  name="Wing_1"
                  castShadow
                  receiveShadow
                  geometry={nodes.Wing_1.geometry}
                  material={materials.Wing_1}
                  morphTargetDictionary={nodes.Wing_1.morphTargetDictionary}
                  morphTargetInfluences={nodes.Wing_1.morphTargetInfluences}
                />
              </group>
              <group name="MorphMainGroup_1">
                <mesh
                  visible={false}
                  name="Wing_1_1"
                  castShadow
                  receiveShadow
                  geometry={nodes.Wing_1_1.geometry}
                  material={materials.Wing_1}
                  morphTargetDictionary={nodes.Wing_1_1.morphTargetDictionary}
                  morphTargetInfluences={nodes.Wing_1_1.morphTargetInfluences}
                />
              </group>
            </group>
            <group name="Object_12" position={[50.986, -30, -50]}>
              <group visible={false} name="MorphMainGroup_2">
                <mesh
                  name="Wing_1_2"
                  castShadow
                  receiveShadow
                  geometry={nodes.Wing_1_2.geometry}
                  material={materials.Wing_1}
                  morphTargetDictionary={nodes.Wing_1_2.morphTargetDictionary}
                  morphTargetInfluences={nodes.Wing_1_2.morphTargetInfluences}
                />
              </group>
              <group visible={false} name="MorphMainGroup_3" position={[50.986, -10, -5]}>
                <mesh
                  name="Wing_1_3"
                  castShadow
                  receiveShadow
                  geometry={nodes.Wing_1_3.geometry}
                  material={materials.Wing_1}
                  morphTargetDictionary={nodes.Wing_1_3.morphTargetDictionary}
                  morphTargetInfluences={nodes.Wing_1_3.morphTargetInfluences}
                />
              </group>
            </group>
          </group>
          <group
            name="Object_17"
            position={[2.57, -0.137, 12.826]}
            rotation={[Math.PI, -0.049, 0]}
          >
            <group name="TimeframeMainGroup">
              <group name="Object_19">
                <mesh
                  name="Cylinder001_7_0"
                  castShadow
                  receiveShadow
                  geometry={nodes.Cylinder001_7_0.geometry}
                  material={materials.Cylinder001}
                />
              </group>
            </group>
            <group name="TimeframeMainGroup_1">
              <group name="Object_22">
                <mesh
                  name="Cylinder001_7_0_1"
                  castShadow
                  receiveShadow
                  geometry={nodes.Cylinder001_7_0_1.geometry}
                  material={materials.Cylinder001}
                />
              </group>
            </group>
          </group>
          <group
            name="Object_24"
            position={[1.182, 0, 4.719]}
            rotation={[-Math.PI / 2, 0, 0]}
          >
            <group name="Object_25" position={[-29.375, 0, 0]}>
              <group name="MorphMainGroup_4">
                <mesh
                  name="Line001"
                  castShadow
                  receiveShadow
                  geometry={nodes.Line001.geometry}
                  material={materials.Wing_1}
                  morphTargetDictionary={nodes.Line001.morphTargetDictionary}
                  morphTargetInfluences={nodes.Line001.morphTargetInfluences}
                />
              </group>
              <group visible={false} name="MorphMainGroup_5">
                <mesh
                  name="Line001_1"
                  castShadow
                  receiveShadow
                  geometry={nodes.Line001_1.geometry}
                  material={materials.Wing_1}
                  morphTargetDictionary={nodes.Line001_1.morphTargetDictionary}
                  morphTargetInfluences={nodes.Line001_1.morphTargetInfluences}
                />
              </group>
            </group>
            <group name="Object_30" position={[-29.375, 0, 0]}>
              <group visible={false} name="MorphMainGroup_6">
                <mesh
                  name="Line001_2"
                  castShadow
                  receiveShadow
                  geometry={nodes.Line001_2.geometry}
                  material={materials.Wing_1}
                  morphTargetDictionary={nodes.Line001_2.morphTargetDictionary}
                  morphTargetInfluences={nodes.Line001_2.morphTargetInfluences}
                />
              </group>
              <group visible={false} name="MorphMainGroup_7">
                <mesh
                  name="Line001_3"
                  castShadow
                  receiveShadow
                  geometry={nodes.Line001_3.geometry}
                  material={materials.Wing_1}
                  morphTargetDictionary={nodes.Line001_3.morphTargetDictionary}
                  morphTargetInfluences={nodes.Line001_3.morphTargetInfluences}
                />
              </group>
            </group>
          </group>
        </group>

         {/* Mesh for butterfly animation */}
        <mesh
          visible={false}
          name="Line001_4"
          castShadow
          receiveShadow
          geometry={nodes.Line001_4.geometry}
          material={materials.Wing_1}
          morphTargetDictionary={nodes.Line001_4.morphTargetDictionary}
          morphTargetInfluences={nodes.Line001_4.morphTargetInfluences}
          position={[-28.193, 0, 4.719]}
          rotation={[-Math.PI / 2, 0, 0]}
        />
        <mesh
          visible={false}
          name="Line001_5"
          castShadow
          receiveShadow
          geometry={nodes.Line001_5.geometry}
          material={materials.Wing_1}
          morphTargetDictionary={nodes.Line001_5.morphTargetDictionary}
          morphTargetInfluences={nodes.Line001_5.morphTargetInfluences}
          position={[-28.193, 0, 4.719]}
          rotation={[-Math.PI / 2, 0, 0]}
        />
        <mesh
          visible={false}
          name="Line001_6"
          castShadow
          receiveShadow
          geometry={nodes.Line001_6.geometry}
          material={materials.Wing_1}
          morphTargetDictionary={nodes.Line001_6.morphTargetDictionary}
          morphTargetInfluences={nodes.Line001_6.morphTargetInfluences}
          position={[-28.193, 0, 4.719]}
          rotation={[-Math.PI / 2, 0, 0]}
        />
        <mesh
          visible={false}
          name="Line001_7"
          castShadow
          receiveShadow
          geometry={nodes.Line001_7.geometry}
          material={materials.Wing_1}
          morphTargetDictionary={nodes.Line001_7.morphTargetDictionary}
          morphTargetInfluences={nodes.Line001_7.morphTargetInfluences}
          position={[-28.193, 0, 4.719]}
          rotation={[-Math.PI / 2, 0, 0]}
        />
        <mesh
          visible={false}
          name="Cylinder001_7_0_2"
          castShadow
          receiveShadow
          geometry={nodes.Cylinder001_7_0_2.geometry}
          material={materials.Cylinder001}
          position={[2.57, -0.137, 12.826]}
          rotation={[Math.PI, -0.049, 0]}
        />
        <mesh
          visible={false}
          name="Wing_1_4"
          castShadow
          receiveShadow
          geometry={nodes.Wing_1_4.geometry}
          material={materials.Wing_1}
          morphTargetDictionary={nodes.Wing_1_4.morphTargetDictionary}
          morphTargetInfluences={nodes.Wing_1_4.morphTargetInfluences}
          // position={[30.205, 0.013, 2.565]}

          position={[38.205, -30, -10]}
          rotation={[-Math.PI / 2, 0, 0]}
        />
        <mesh
          visible={false}
          name="Wing_1_5"
          castShadow
          receiveShadow
          geometry={nodes.Wing_1_5.geometry}
          material={materials.Wing_1}
          morphTargetDictionary={nodes.Wing_1_5.morphTargetDictionary}
          morphTargetInfluences={nodes.Wing_1_5.morphTargetInfluences}
          position={[30.205, 0.013, 2.565]}
          rotation={[-Math.PI / 2, 0, 0]}
        />
        <mesh
          visible={false}
          name="Wing_1_6"
          castShadow
          receiveShadow
          geometry={nodes.Wing_1_6.geometry}
          material={materials.Wing_1}
          morphTargetDictionary={nodes.Wing_1_6.morphTargetDictionary}
          morphTargetInfluences={nodes.Wing_1_6.morphTargetInfluences}
          position={[30.205, 0.013, 2.565]}
          rotation={[-Math.PI / 2, 0, 0]}
        />
        <mesh
          visible={false}
          name="Wing_1_7"
          castShadow
          receiveShadow
          geometry={nodes.Wing_1_7.geometry}
          material={materials.Wing_1}
          morphTargetDictionary={nodes.Wing_1_7.morphTargetDictionary}
          morphTargetInfluences={nodes.Wing_1_7.morphTargetInfluences}
          // position={[30.205, 0.013, 2.565]}
          position={[30.205, -50, 2.565]}
          rotation={[-Math.PI / 2, 0, 0]}
        />
      </group>
    </group>
  );
}

useGLTF.preload("./models/butterfly/scene.gltf");




